export function getTurkishPlural(word) {
  // List of Turkish plural suffixes based on vowel harmony
  const pluralSuffixes = {
    a: "lar",
    e: "ler",
    ı: "lar",
    i: "ler",
    o: "lar",
    ö: "ler",
    u: "lar",
    ü: "ler",
  };

  // Extract the last two characters of the word
  const lastTwoChars = word.slice(-2);

  // Check if the last character exists in the pluralSuffixes object
  if (lastTwoChars.slice(-1) in pluralSuffixes) {
    // Replace the last character with the corresponding plural suffix
    const plural = word + pluralSuffixes[lastTwoChars.slice(-1)];
    return plural;
  }

  // Check if the character before the last character exists in the pluralSuffixes object
  if (lastTwoChars.charAt(0) in pluralSuffixes) {
    // Replace the character before the last character with the corresponding plural suffix
    const plural = word + pluralSuffixes[lastTwoChars.charAt(0)];
    return plural;
  }

  // Return the word as is if neither the last character nor the character before the last character have defined plural suffixes
  return word;
}
